import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bookmarks-sharp",
  "use": "icon-bookmarks-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-bookmarks-sharp\"><title>Bookmarks</title><path d=\"M112 0v48h304v368l48 32V0H112z\" /><path d=\"M48 80v432l168-124 168 124V80H48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol